<template>
    <div class="descuentos-section">
        <div class="descuentos-content">
            <h2 class="descuentos-title fuente-posm">
                ¿No te Cuadran los Descuentos?
            </h2>
            <p class="descuentos-text fuente-nova">
                Cada descuento aplicado en tu punto de venta se registra automáticamente con fecha, responsable y motivo. Sin excusas, sin descuentos fantasma.
                <br><br>
                Nuestro agente de IA analiza cada justificación y te alerta cuando detecta algo fuera de lo normal: descuentos excesivos, motivos vagos o patrones que indican mal uso. Recupera el control de tu margen sin auditorías manuales interminables.
            </p>
        </div>
        <div class="descuentos-image">
            <img :src="a59" alt="Descuentos">
        </div>
    </div>
</template>

<script>
export default {
    name: 'DescuentosNew',
    data() {
        return {
            a59: require('@/assets/images/a59.webp')
        }
    }
}
</script>

<style lang="css" scoped>
.descuentos-section {
    width: 100vw;
    height: 100vh;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: center;
    padding: 40px 60px;
    box-sizing: border-box;
    scroll-snap-align: start;
    gap: 40px;
}

.descuentos-image {
    flex: 0 0 auto;
    display: flex;
    justify-content: center;
    align-items: center;
    order: 2;
}

.descuentos-image img {
    width: 400px;
    height: auto;
}

.descuentos-content {
    flex: 1;
    max-width: 700px;
    order: 1;
}

.descuentos-title {
    color: var(--color-2);
    font-size: 68px;
    line-height: 1.1;
    margin: 0 0 20px 0;
}

.descuentos-text {
    color: var(--color-3);
    font-size: 25px;
    line-height: 1.3;
    margin: 0;
    padding-left: 10px;
}

/* Tablet */
@media (max-width: 992px) and (min-width: 769px) {
    .descuentos-title {
        font-size: 60px;
    }

    .descuentos-text {
        font-size: 22px;
    }

    .descuentos-image img {
        width: 320px;
    }
}

/* Mobile */
@media (max-width: 768px) {
    .descuentos-section {
        flex-direction: column;
        justify-content: flex-start;
        height: 100vh;
        padding: 100px 20px 40px 20px;
        gap: 20px;
    }

    .descuentos-content {
        order: 1;
        max-width: 100%;
        flex: none;
    }

    .descuentos-image {
        order: 2;
        width: 100%;
        flex: 1;
        display: flex;
        align-items: flex-start;
        justify-content: center;
        padding-top: 20px;
    }

    .descuentos-image img {
        width: 80%;
        max-width: 320px;
    }

    .descuentos-title {
        font-size: 24px;
        line-height: 1.2;
        margin: 0 0 10px 0;
    }

    .descuentos-text {
        font-size: 15px;
        padding-left: 10px;
        margin: 0;
    }
}
</style>
